import React, { Component } from "react";
import { getCurrentUser, updateCurrentUser } from "../../helpers/parseHelper";
import { Form, Input } from "antd";
import { ActionBtn } from "./style";
import { notification } from "../../components";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { connect } from "react-redux";
import authAction from "../../redux/auth/actions";

const { checkAuthorization, logout } = authAction;

class EditCurrentUser extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {
                name: '',
                oldPassword: '',
                password: ''
            },
            loading: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillUnmount() {
        this.formRef.current.resetFields();
    }

    loadData = () => {
        const user = this.props.Auth;
        const data = {
            name: user?.name,
        };

        this.setState({ data }, () => {
            this.formRef.current.setFieldsValue(data);
        });
    };

    setLoading = (value) => {
        this.setState({ loading: value });
    };

    handleSubmit = async () => {
        const promise = this.formRef.current.validateFields();
        const values = await Promise.resolve(promise);
        this.setLoading(true);
        if (values) {
            try {
                const { status, message } = await updateCurrentUser(values);

                notification(status, message);

                if (status === "success") {
                    if(this.formRef.current.getFieldValue("password")) {
                        this.props.logout();
                    }
                    this.props.onSuccess();
                }
            } catch (error) {
                notification("error", error.message);
            }
        }

        this.setLoading(false);
    };
    render() {
        return (
            <Form layout="vertical" ref={this.formRef} onFinish={this.handleSubmit}>
                {/* <Form.Item
                    name="username"
                    label="Username"
                    rules={[
                        {
                            required: true,
                            message: "Please fill data!",
                        },
                    ]}
                >
                    <Input />
                </Form.Item> */}
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                        {
                            required: true,
                            message: "Please fill data!",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="oldPassword"
                    label="Old Password"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const newPassword = getFieldValue("password");

                                // If new password is not being changed, do not require old password
                                if (!newPassword && !value) {
                                    return Promise.resolve();
                                }

                                if (!value) {
                                    return Promise.reject(new Error("Old password is required when changing password."));
                                }

                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input.Password iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                </Form.Item>

                <Form.Item
                    name="password"
                    label="New Password"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const oldPassword = getFieldValue("oldPassword");

                                // If no password change intended
                                if (!oldPassword && !value) {
                                    return Promise.resolve();
                                }

                                if (!value) {
                                    return Promise.reject(new Error("New password is required."));
                                }

                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input.Password iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                </Form.Item>

                <Form.Item style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                    <ActionBtn
                        type="primary"
                        htmlType="submit"
                        // onClick={this.handleSubmit}
                        loading={this.state.loading}
                        style={{
                            width: 120,
                        }}
                    >
                        Submit
                    </ActionBtn>
                </Form.Item>
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({ Auth: state.Auth });

export default connect(mapStateToProps, {logout})(EditCurrentUser);

// export default EditCurrentUser;